import { inject } from "@angular/core";
import { CanActivateFn } from "@angular/router";
import { APTContext } from "src/app/services/aptContext/apt-context";
import { waitForEngagementDetailsFetched } from "src/standard/guards/can-match/waitForEngagementDetailsFetched";
import { waitForReviewEngagementFetched } from "src/standard/guards/can-match/waitForReviewEngagementFetched";

// NOTE: fill in more types as needed. This is not an exhaustive list.
export type EngagementType = "Audit" | "Review" | "Micro Audit";
export type EngagementTypes = EngagementType[];
const REVIEW_ENGAGEMENT_TYPE = "Review";

export const EngagementTypeCanActivateGuard = (
  targetEngagementTypes: EngagementTypes,
): CanActivateFn => {
  return async (route) => {
    const aptContext = inject(APTContext);

    try {
      // Only wait for review engagement if we're checking for Review type
      const waitPromises = [waitForEngagementDetailsFetched(aptContext)];
      if (targetEngagementTypes.includes(REVIEW_ENGAGEMENT_TYPE)) {
        waitPromises.push(waitForReviewEngagementFetched(aptContext));
      }

      await Promise.all(waitPromises);

      const isAllowed = targetEngagementTypes.some((targetEngagementType) => {
        if (targetEngagementType === "Audit") {
          return aptContext.isAuditEngagement();
        }

        if (targetEngagementType === "Review") {
          return aptContext.isReviewEngagement();
        }

        if (targetEngagementType === "Micro Audit") {
          return aptContext.isMicroAuditEngagement();
        }

        return false;
      });

      return isAllowed;
    } catch (error) {
      return false;
    }
  };
};
